<template>
  <div>
    <div :style="getSpacerStyles" />
  </div>
</template>

<script setup>
import { computed } from 'vue';

defineOptions({
  name: 'SpacerBlock',
});

const props = defineProps({
  config: {
    type: Object,
    default: () => ({}),
  },
});

const getSpacerStyles = computed(() => {
  const spacer = props.config?.spacer ?? {};
  const backgroundColor = spacer.isTransparent ? '#ffffff00' : spacer.backgroundColor;
  return {
    height: (spacer.height ?? 0) + 'px',
    'background-color': backgroundColor,
  };
});
</script>
